import type { CSSProperties } from 'react';
import type { IPopUpViewProps } from './PopUpView';
import styles from './PopUpView.module.css';

export enum StyleElem {
    Container = 'Container',
    AlertContainer = 'AlertContainer',
    AlertTitle = 'AlertTitle',
    AlertOptionYes = 'AlertOptionYes',
    AlertOptionNo = 'AlertOptionNo',
}

const DEFAULTS: Record<StyleElem, CSSProperties> = {
    [StyleElem.Container]: {},
    [StyleElem.AlertContainer]: {},
    [StyleElem.AlertTitle]: {},
    [StyleElem.AlertOptionYes]: {},
    [StyleElem.AlertOptionNo]: {},
};

const PROPS_APPLICATOR: Record<StyleElem, (props: IPopUpViewProps) => CSSProperties> = {
    [StyleElem.Container]: (props: IPopUpViewProps) => ({
        opacity: props.show ?? false ? 1 : 0,
        pointerEvents: props.show ?? false ? 'auto' : 'none',
    }),
    [StyleElem.AlertContainer]: (props: IPopUpViewProps) => ({}),
    [StyleElem.AlertTitle]: (props: IPopUpViewProps) => ({}),
    [StyleElem.AlertOptionYes]: (props: IPopUpViewProps) => ({}),
    [StyleElem.AlertOptionNo]: (props: IPopUpViewProps) => ({}),
};

export function classNameForElement(element: StyleElem, props: IPopUpViewProps): string {
    const name = element.toString();
    const classLoad = styles[name];
    return classLoad || '';
}

export function styleForElement(element: StyleElem, props: IPopUpViewProps): CSSProperties {
    const style = { ...DEFAULTS[element], ...PROPS_APPLICATOR[element](props) };

    return style;
}
